<template>
  <vue-global-frame :user='User' :handleLogout='logout' :baseURL="baseAPIURL" :authToken="authToken" ref="vueglobalframe">
    <div slot="app-frame-slot">
      <aaModal v-if='toggleAvail' @closemodal='toggleAvail = false'>
        <span slot='modal-title'>Set Availability</span>
        <availability slot='modal-body' @cancel='toggleAvail = false' @submitavail='submitAvail($event)' :user='User'></availability>
      </aaModal>
      <div id="left-side-nav-container" v-bind:class="{'side-nav-collapsed' : sideNavCollapsed}">
        <main-nav @availEvent='handleToggleAvail()' :sideNavCollapsed='sideNavCollapsed' :user='User' :pc-func='pcFunc' :recent-func='loadRecent'
          :high-func='loadHighReport' :low-func='loadLowReport' :bim-func='loadBIM' :lost-func='loadLost' :hide-user-info='true'
          :cust-search-func='custSearchFunc'></main-nav>
      </div>
      <div id="main-container" class="container-fluid" v-bind:class="{'side-nav-collapsed' : sideNavCollapsed}">
        <div id="action-bar">
          <button class='btn btn-gray-lt mr-2' @click='toggleSideNav()'>
            <img src="static/assets/img/SVGIcons/icon-hamburger-blue.svg" style="height:auto; width:23px;" />
          </button>
        </div>
        <router-view id='mainRouterContainer'></router-view>
      </div>
      <div id="right-side-nav-container">
        <div>right side nav container</div>
      </div>
      <div id="right-side-overlay-container">
        <div>right side overlay container</div>
      </div>
    </div>
  </vue-global-frame>
</template>

<script>
  import MainNav from '@/components/Nav/MainNav'
  import VueGlobalFrame from '@autoalert/vueglobalframe';
  import AaModal from '@/components/AaModal/AaModal.vue'
  import Availability from '@/components/Availability/Availability'
  import Profile from '@/components/Profile/Profile'
  import EventBus from '@/lib/utilities/eventBus.js'
  import {
    webAuth
  } from '../../auth/index'
  import {
    mapGetters
  } from 'vuex'
  import {
    UserAvailability
  } from '../../lib/utilities/enums';
  import {
    MessengerAPIClient
  } from '@/lib/data_access/messenger.js'

  export default {
    name: 'web',
    components: {
      MainNav,
      VueGlobalFrame,
      AaModal,
      Availability,
      Profile
    },
    data() {
      return {
        collapseSideNav: false,
        toggleAvail: false,
        showProfileModal: false,
        baseAPIURL: process.env.MOTOFUZE_API
      }
    },
    computed: {
      ...mapGetters(['OIDCUser', 'sideNavCollapsed', 'User', 'authToken'])
    },
    methods: {
      toggleSideNav() {
        let vm = this;
        vm.$store.dispatch('toggleSideNav', !vm.sideNavCollapsed)
      },
      pcFunc() {
        let vm = this;
        vm.$router.push({
          query: Object.assign({}, vm.$route.query, {
            report: ''
          })
        })
      },
      loadHighReport() {
        let vm = this;
        vm.$router.push({
          query: Object.assign({}, vm.$route.query, {
            report: 'highIntensity'
          })
        })
      },
      loadLowReport() {
        let vm = this;
        vm.$router.push({
          query: Object.assign({}, vm.$route.query, {
            report: 'losingIntensity'
          })
        })
      },
      loadLost() {
        let vm = this;
        vm.$router.push({
          query: Object.assign({}, vm.$route.query, {
            report: 'lostLeads'
          })
        })
      },
      loadRecent() {
        let vm = this;
        vm.$router.push({
          query: Object.assign({}, vm.$route.query, {
            report: 'recent'
          })
        })
      },
      loadBIM() {
        let vm = this;
        vm.$router.push({
          query: Object.assign({}, vm.$route.query, {
            report: 'soldBim'
          })
        })
      },
      custSearchFunc() {
        let vm = this;

        vm.$router.push({
          query: Object.assign({}, vm.$route.query, {
            report: 'search'
          })
        })

      },
      userInfoHandlers: function () {
        let vm = this;
        return {
          availabilityToggler: vm.availabilityToggler
        }
      },
      availabilityToggler: function () {
        let vm = this;
        if (vm.User.Availability == UserAvailability.NotAvailable) {
          MessengerAPIClient.clockIn().then(function () {})
        } else {
          vm.toggleAvail = true
        }
      },
      profileHandler: function () {
        let vm = this;
        vm.showProfileModal = true;
      },
      handleProfileClose: function () {
        let vm = this;
        this.showProfileModal = false;
      },
      handleToggleAvail: function () {
        let vm = this;
        vm.toggleAvail = false
      },
      submitAvail(availabilityPayload) {
        let vm = this;
        MessengerAPIClient.setAvailability(availabilityPayload).then(function () {
          vm.toggleAvail = false
        })
      },
      logout() {
        let vm = this;
        webAuth.logout();
      }
    },
    created: function () {
      EventBus.$on('handleStoreUpdateNotification', (stores) => {
        try {
          if (this.$refs.vueglobalframe)
            this.$refs.vueglobalframe.handleStoreUpdateNotification(stores);
        } catch (err) {
          console.log("Error handling store update: ", err);
        }
      });
    }
  }

</script>

<style lang='scss' scoped>
  @import '../../../styles/custom.scss';

  #action-bar {
    width: 100%;
    padding: 10px;
    display: flex;
    min-height: 60px;
    max-height: 60px;
  }

  #left-side-nav-container {
    max-width: 300px;
    min-width: 300px;
    background-color: $white;
    min-height: calc(100vh - 60px);
    position: absolute;
    top: 0;
    left: 0;
    border-right: 1px solid $gray-lt;
    transition: $Transition-speed;
    overflow-x: hidden;
    &.side-nav-collapsed {
      max-width: 44px;
      min-width: 44px;
    }
  }

  #main-container {
    background-color: $gray-lt;
    transition: $Transition-speed;
    height: calc(100vh - 60px);
    padding-left: 300px;
    padding-right: 0; // padding-right:300px;
    &.side-nav-collapsed {
      padding-left: 45px;
    }

  }

  #right-side-nav-container {
    display: none;
    max-width: 300px;
    min-width: 300px;
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    border-left: 1px solid $gray-lt;
    transition: $Transition-speed;
  }

  #right-side-overlay-container {
    display: none;
    max-width: 300px;
    min-width: 300px;
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    z-index: 1000;
    background: $white;
    box-shadow: -15px 0 30px transparentize($gray-dk, 0.5);
    transition: $Transition-speed;
  }

</style>



// WEBPACK FOOTER //
// src/views/Web/Web.vue